import styles from './addProductModalTabs.module.css';
import Icon from './IconMassnahmen.svg';
import IconUpload from './IconUpload.svg';

export type Column<T, K extends keyof T = keyof T> = {
    key: K;
    label: string;
    render?: (value: T[K], row: T) => React.ReactNode;
};
type TableProps<T> = {
    data: T[];
    columns: Column<T>[];
    isDocument?: boolean;
    empty: {
        title: string;
        text: string;
    }
};

export function Table<T>({ data, columns, isDocument, empty }: TableProps<T>) {
    return <div className={styles["tab-table"]}>
        <table className={styles["table"]}>
            <thead>
                <tr>
                    {columns.map((column) => (
                        <th key={String(column.key)}>{column.label}</th>
                    ))}
                </tr>
            </thead>

            <tbody>
                {!data.length &&
                    <tr>
                        <td colSpan={columns.length} style={{ padding: "0" }}>
                            <div className={styles["table-empty"]}>
                                <img src={isDocument ? IconUpload : Icon} />
                                <p className={styles["table-empty__title"]}>{empty.title}</p>
                                <p className={styles["table-empty__text"]}>{empty.text}</p>
                            </div>
                        </td>
                    </tr>
                }
                {data.map((row, index) => (
                    <tr key={index}>
                        {columns.map((column) => (
                            <td key={String(column.key)}>
                                {column.render
                                    ? column.render(row[column.key], row)
                                    : String(row[column.key])}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
};